export enum UserRole {
  Admin = 'admin',
  Broker = 'broker',
  Carrier = 'carrier',
  Client = 'client',
  None = 'None',
  Market = 'market',
}
